module.exports = require("@jswork/next-compact-object");